export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AuthLayout.vue?vue&type=template&id=97a64376"


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/AuthLayout.vue?vue&type=template&id=97a64376
// module id = R/0O
// module chunks = 41